import React, { useEffect, useContext, useState } from "react"
import { bbottomGrilla, bkCabGrilla, bkCeldaGrilla, clCabGrilla, clCeldaGrilla, diaMes, sizeCelda } from "./general";
import { AppContext } from "./index";

export default function ActividadesCosto({ proyecto }) {
    let { firebase } = useContext(AppContext);
    const [horasP, setHorasP] = useState({}) // horas de las actividades del  proyecto
    const [totales, setTotales] = useState({ horas: 0, previstas: 0, incurridas: 0 })

    useEffect(() => {
        let { resultado, thoras, tprevistas, tincurridas } = firebase.horasActividadesProyecto(proyecto)
        setHorasP(resultado)
        setTotales({ horas: thoras, previstas: tprevistas, incurridas: tincurridas })
    }, [firebase, proyecto]);

    return (
        <div style={Smain}>
            <div style={Stotales}>
                <div style={SceldaT}>Total de horas estimadas:</div>
                <div style={SceldaT}> {totales.horas}</div>
                <div style={SceldaT}>Horas previstas a la fecha:</div>
                <div style={SceldaT}>{totales.previstas}</div>
                <div style={SceldaT}>Horas incurridas:</div>
                <div style={{ ...SceldaT, background: totales.incurridas > totales.previstas * 1.2 ? "red" : totales.incurridas > totales.previstas * 1.1 ? "#AEB404" : "" }}>{totales.incurridas}</div>
            </div>
            <div style={Stitulo}>
                <div >Actividad</div>
                <div >Inicio</div>
                <div >Fin</div>
                <div >Avance</div>
                <div >Hs plan</div>
                <div >Hs s/%</div>
                <div >Hs real</div>
                <div >Estado</div>
            </div>
            <div style={SactividadesCosto}>
                {Object.values(horasP).map((a, ind) =>
                    <div style={Sactividad} key={ind}>
                        <div style={{ ...Scelda, textAlign: "left" }}>{a.nombre}</div>
                        <div style={Scelda}>{diaMes(a.inicio)}</div>
                        <div style={Scelda}>{diaMes(a.finEstimado)}</div>
                        <div style={Scelda}>{a.progreso + "%"}</div>
                        <div style={Scelda}>{a.horas}</div>
                        <div style={Scelda}>{a.horasPrevistas}</div>
                        <div style={{ ...Scelda, color: a.horasIncurridas > a.horasPrevistas * 1.2 ? "red" : a.horasIncurridas > a.horasPrevistas * 1.1 ? "#AEB404" : clCeldaGrilla }}>{a.horasIncurridas}</div>
                        <div style={Scelda}>
                            <div style={{ fontSize: "1.5vh", margin: "2px 0px 2px 0px ", padding: "5px 0px 5px 5px", borderRadius: "5px", background: a.estado === "terminada" ? "#81F781" : a.estado === "ejecutando" ? "#E0F8F7" : "#F5F6CE" }}>{a.estado}</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const Smain = {
    paddingTop: "10px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
}

const SactividadesCosto = {
    paddingTop: "5px",
    maxHeight: "52vh",
    overflowY: "auto",
    width: "100%",
}

const Stitulo = {
    display: "grid",
    gridTemplateColumns: "30% 10% 10% 10% 10% 10% 10% 10% ",
    background: bkCabGrilla,
    color: clCabGrilla,
    fontSize: "2vh",
    fontWeight: 700,
    padding: "8px 0px 8px 3px",
    textAlign: "left",
    height: "7vh",
    width: "100%",
}

const Sactividad = {
    display: "grid",
    gridTemplateColumns: "30% 10% 10% 10% 10% 10% 10% 10% ",
    marginBottom: "2px",
    background: bkCeldaGrilla,
    minHeight: "6vh",
    overflow: "hidden",
    width: "100%",
}

const Scelda = {
    borderBottom: bbottomGrilla,
    padding: "5px 2px 5px 2px",
    fontSize: sizeCelda,
    color: clCeldaGrilla,
    width: "100%",
    textAlign: "center"
}

const Stotales = {
    display: "grid",
    gridTemplateColumns: "70% 30% ",
    marginBottom: "15px",
    background: "#CEE3F6",
    borderRadius: "10px",
    border: "2px solid #212121",
    alignItems: "center",
    fontSize: "2vh",
    fontWeight: 700,
    width: "350px",
}

const SceldaT = {
    padding: "5px 2px 5px 2px",
    fontSize: "2.2",
    color: clCeldaGrilla,
    textAlign: "center",
    margin: "5px"
}